module.exports = __webpack_public_path__ + "f8084a30eab0a47fb3e975afa54352f0.svg";